/**
 * Arquivo: src/utils/faturasCartao.ts
 * Versão: 4.10.96
 * Data: 15/09/2026
 * Situação da fatura derivada da baixa vinculada, sem alterar o histórico da compra.
 */
import type { FaturaCartao } from '../types/database'

export type PagamentoFaturaCartao = {
  id: string
  fatura_id?: string | null
  status?: string | null
  valor_realizado?: number | null
  data_realizacao?: string | null
  conta_realizada_id?: string | null
}

export function pagamentoDaFatura(fatura: FaturaCartao, lancamentos: PagamentoFaturaCartao[]): PagamentoFaturaCartao | undefined {
  const vinculado = fatura.lancamento_id && lancamentos.find(l => l.id === fatura.lancamento_id)
  const relacionados = lancamentos.filter(l => l.fatura_id === fatura.id)
  if (vinculado && String(vinculado.status || '').toUpperCase() === 'PAGO') return vinculado
  return relacionados.find(l => String(l.status || '').toUpperCase() === 'PAGO') || vinculado || relacionados[0]
}

export function situacaoFaturaCartao(fatura: FaturaCartao, lancamento?: PagamentoFaturaCartao) {
  const paga = lancamento
    ? String(lancamento.status || '').toUpperCase() === 'PAGO'
    : String(fatura.status || '').toUpperCase() === 'PAGA'
  return {
    paga,
    status: paga ? 'PAGA' : String(lancamento?.status || fatura.status || 'ABERTA').toUpperCase(),
    valorRealizado: paga ? Number(lancamento?.valor_realizado ?? fatura.valor ?? 0) : null,
    dataPagamento: paga ? lancamento?.data_realizacao || null : null,
    contaPagamentoId: paga ? lancamento?.conta_realizada_id || null : null,
  }
}
